import { Controller } from "@hotwired/stimulus"

// Provides slide-in/out behaviour for reusable toast notifications.
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 5000 }
  }

  connect() {
    this.timeout = null
    requestAnimationFrame(() => {
      this.element.classList.remove("translate-y-6", "opacity-0")
      this.element.classList.add("translate-y-0", "opacity-100")
    })
    this.startTimer()
  }

  disconnect() {
    this.clearTimer()
  }

  pause() {
    this.clearTimer()
  }

  resume() {
    this.startTimer()
  }

  dismiss() {
    this.clearTimer()
    this.element.classList.add("translate-y-6", "opacity-0")
    this.element.classList.remove("translate-y-0", "opacity-100")

    this.element.addEventListener("transitionend", () => {
      this.element.remove()
    }, { once: true })
  }

  startTimer() {
    if (this.durationValue <= 0) return
    this.clearTimer()
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  clearTimer() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
